import {
  beCampaignsBuilderGetCampaignHistory,
  beCampaignsBuilderGetEmailCampaignById,
  beCampaignsBuilderGetLisOfCampaigns,
  beCampaignsBuilderGetMapiCampaign,
  beCampaignsBuilderPutCampaign,
  beCampaignsBuilderPutMapiCampaign,
  beCampaignsDeleteCampaigns,
  beCampaignsPostExecuteTest
} from 'Api/beCampaign'
import {
  beContentSourceGetListOfContents,
  beContentSourceGetListOfStatus,
  beContentSourceGetSource
} from 'Api/beContentSource'
import { beMessGetUserChannels } from 'Api/beMessApi'
import { beSendPostOnSend } from 'Api/beSendNWebApi'

import { statisticsGetMessageSent } from 'Api/statisticsApi'
import {
  evalCondition,
  storeGet,
  STORE_KEY_ID_LIST,
  STORE_KEY_USER
} from 'mailup-react-helpers'

import {
  CAMPAIGN_CHANNEL_EMAIL,
  CAMPAIGN_CHANNEL_MESSENGER,
  CAMPAIGN_CHANNEL_TELEGRAM
} from 'Constants/'
import { beSendGetUncompleted } from 'Api/beSendApi'

export async function getUserChannels() {
  const user = storeGet(STORE_KEY_USER)
  const resp = await beMessGetUserChannels(user.Id)
  return resp
}

// ???
export async function getAllChannelsPermission(idUser) {
  const resp = await beMessGetUserChannels(idUser)
  return resp
}

export async function getListOfCampaigns(params) {
  const idList = parseInt(storeGet(STORE_KEY_ID_LIST))
  const resp = await beCampaignsBuilderGetLisOfCampaigns(idList, params)
  return resp
}

export async function getEmailCampaignById(idCampaign) {
  const resp = await beCampaignsBuilderGetEmailCampaignById(idCampaign)
  return resp
}

export async function getSourceById(idSource) {
  const resp = await beContentSourceGetSource(idSource)
  return resp
}

export async function getListOfStatus(idSource, params) {
  const resp = await beContentSourceGetListOfStatus(idSource, params)
  return resp
}

export async function postOnSent(IdMessages) {
  const idList = parseInt(storeGet(STORE_KEY_ID_LIST))
  const params = { IdMessages, Completed: false, Started: true }
  const resp = await beSendPostOnSend(idList, params)
  return resp
}

export async function getMessageSent(idMessage) {
  const idList = parseInt(storeGet(STORE_KEY_ID_LIST))
  const params = { types: 'EI' }
  const resp = await statisticsGetMessageSent(idList, idMessage, params)
  return resp
}

export async function getMapiCampaign(idCampaign) {
  const resp = await beCampaignsBuilderGetMapiCampaign(idCampaign)
  return resp
}

export async function getCampaignSentHistory(idCampaign, params) {
  const resp = await beCampaignsBuilderGetCampaignHistory(idCampaign, params)
  return resp
}

export async function getContents(idCampaign, params) {
  const resp = await beContentSourceGetListOfContents(idCampaign, params)
  return resp
}

export async function updateStatus(idCampaign, params, type) {
  const idList = parseInt(storeGet(STORE_KEY_ID_LIST))
  let resp
  if (type === CAMPAIGN_CHANNEL_EMAIL) {
    resp = await beCampaignsBuilderPutCampaign(idList, idCampaign, params)
  } else if (
    type === CAMPAIGN_CHANNEL_MESSENGER ||
    type === CAMPAIGN_CHANNEL_TELEGRAM
  ) {
    resp = await beCampaignsBuilderPutMapiCampaign(idList, idCampaign, params)
  }

  return resp
}

export async function fetchSourceById(idSource) {
  const source = await getSourceById(idSource)
  const listOfStatus = await getListOfStatus(idSource, {
    pageSize: 1,
    pageNumber: 1
  })
  return { source, listOfStatus }
}

export async function fetchCampaignDataById(campaignItem) {
  const hasStat = evalCondition('uo:STAT')
  let isOnSent = false
  let isMessageSent = false
  let idMessage = 0

  const mapiResponse = []

  if (
    campaignItem.Status === 1 &&
    campaignItem.Type === CAMPAIGN_CHANNEL_EMAIL
  ) {
    const campaign = await getEmailCampaignById(campaignItem.Id)
    if (campaign !== null) {
      const [pOnSent, messageSent] = await Promise.all([
        postOnSent([campaign.EmailOptions.IdMessage]),
        getMessageSent(campaign.EmailOptions.IdMessage)
      ])
      isOnSent = pOnSent.Items.length > 0 && pOnSent.Items[0].Sent > 0
      isMessageSent = messageSent.Counters.TotalCounters.EI > 0 && hasStat
      idMessage = campaign.EmailOptions.IdMessage
    }
  }

  if (
    campaignItem.Type === CAMPAIGN_CHANNEL_MESSENGER ||
    campaignItem.Type === CAMPAIGN_CHANNEL_TELEGRAM
  ) {
    const mapiArray = []
    mapiArray.push(getMapiCampaign(campaignItem.Id))

    if (campaignItem.Status === 1) {
      const dateTo = new Date()
      dateTo.setMinutes(dateTo.getMinutes() - 5)

      const dateFrom = new Date()
      dateFrom.setDate(dateFrom.getDate() - 90)
      dateFrom.setMinutes(dateFrom.getMinutes() - 5)

      // const dateToStatisticsMapi = moment(dateTo).format('YYYY-MM-DD HH:mm')
      // const dateFromStatisticsMapi = moment(dateFrom).format('YYYY-MM-DD HH:mm')
      const params = {
        idCampaign: campaignItem.Id,
        dateForm: dateFrom.toISOString(),
        dateTo: dateTo.toISOString(),
        // List of status
        // (0 - CampaignStarted,
        // 1 - ContentsHashesUpdated,
        // 2 - RetrivedSendData,
        // 3 - SendCreated,
        // 4 - EnqueConfigurationSaved,
        // 5 - EnqueStarted,
        // 6 - EnqueInProgress,
        // 7 - EnqueDone,
        // 8 - SendStarted,
        // 9 - Error,
        // 10 - RecoverAborted)
        status: [8],
        pageSize: 1,
        pageNumber: 1,
        orderDescending: false
      }

      mapiArray.push(getCampaignSentHistory(campaignItem.Id, params))
      const contentParams = {
        pageSize: 1,
        pageNumber: 1,
        orderBy: 'ContentDate',
        orderDescending: true,
        searchBy: null,
        searchText: null,
        searchDateBy: null,
        searchDateFrom: null,
        searchDateTo: null
      }

      mapiArray.push(getContents(campaignItem.IdSource, contentParams))
    }

    const mapiR = await Promise.all(mapiArray)
    mapiResponse[0] = { type: 'mapy_campaign', response: mapiR[0] }
    mapiResponse[1] = {
      type: 'campaign_sent_history',
      response: mapiR.length > 0 ? mapiR[1] : undefined
    }
    mapiResponse[2] = {
      type: 'contents',
      response: mapiR.length > 0 ? mapiR[2] : undefined
    }
  }

  return {
    isOnSent,
    isMessageSent,
    idCampaign: campaignItem.Id,
    mapiResponse,
    idMessage
  }
}

export async function postCampaignsExecuteTest(idCampaign) {
  const resp = await beCampaignsPostExecuteTest(idCampaign)
  return resp
}

export async function getUncompleted(idMessage) {
  const resp = await beSendGetUncompleted(idMessage)
  return resp
}

export async function deleteCampaign(idCampaign) {
  const resp = await beCampaignsDeleteCampaigns(idCampaign)
  return resp
}
